/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner } from './disable-transaction-upper-limit-for-the-user-account200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { DisableTransactionUpperLimitForTheUserAccount200ResponseReissue } from './disable-transaction-upper-limit-for-the-user-account200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { DisableTransactionUpperLimitForTheUserAccount200ResponseUser } from './disable-transaction-upper-limit-for-the-user-account200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup } from './disable-transaction-upper-limit-for-the-user-account200-response-user-account-group';

/**
 * 
 * @export
 * @interface DisableTransactionUpperLimitForTheUserAccount200Response
 */
export interface DisableTransactionUpperLimitForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'availableCurrencies': Array<DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'availableMerchantCategories': Array<DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {DisableTransactionUpperLimitForTheUserAccount200ResponseUser}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'user': DisableTransactionUpperLimitForTheUserAccount200ResponseUser;
    /**
     * 
     * @type {DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'userAccountGroup'?: DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {DisableTransactionUpperLimitForTheUserAccount200ResponseReissue}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'reissue'?: DisableTransactionUpperLimitForTheUserAccount200ResponseReissue | null;
}

export const DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum = typeof DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum];


